import script from "./VariantForm.vue?vue&type=script&setup=true&lang=js"
export * from "./VariantForm.vue?vue&type=script&setup=true&lang=js"

import "./VariantForm.vue?vue&type=style&index=0&id=580e7195&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-580e7195"]])

export default __exports__